// host page for the list of all Experimental Data
// fetch the information from the server

import React from 'react';


class ApplicationCase extends React.Component {
    constructor(props){
        super(props)
    }

    render(){
        return (
            <div>
                <ul>
                    No idea what is supposed to appear here.
                </ul>
            </div>
        )
    }

}

export default ApplicationCase;
